let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4BYvo")).then(() => parcelRequire('3m5cp'));